import quercusApi from '../apis/quercusApi';

export const editType = async (url, body) => {
    return quercusApi.patch(url, body, {
        responseType: 'blob',
    });
};
